import React from "react";
import { Button } from "@mui/material";
import styles from "../side.module.scss";
import { newCloseIcon, arrowIcon } from "../../../../../constant";
import { TERMS_AND_CONTACT_ARR } from "../../../../../constant/dummyData";
import { GA_LABEL_ENUMS, triggerGAEvent } from "../../../../../constant/google-analytics/GAEvents";
import { DialogSelected } from "../../../../../constant/common";
import { APP_VERSION } from "../../../../../constant/environment";
import { colors, palette, br } from "../../../../../styles/design-tokens";

interface SideBarFooterProps {
  userInfo: any;
  isProduction: boolean;
  showGetHelpOptions: boolean;
  setShowGetHelpOptions: (show: boolean) => void;
  toggleSidebar: () => void;
  handleSelect: (value: string) => void;
  handleSignIn: () => void;
  setLoginCreateAccountState: (state: any) => void;
  setShowZoho: (show: boolean) => void;
  children?: React.ReactNode;
}

const SideBarFooter: React.FC<SideBarFooterProps> = ({
  userInfo,
  isProduction,
  showGetHelpOptions,
  setShowGetHelpOptions,
  toggleSidebar,
  handleSelect,
  handleSignIn,
  setLoginCreateAccountState,
  setShowZoho,
  children,
}) => {
  return (
    <div className={styles.subSideBar}>
      {!userInfo?.loggedIn ? (
        <div className={styles.closeCard}>
          <Button
            className={styles.closeButton}
            endIcon={<img src={newCloseIcon} alt="Close" className={styles.closeIcon} />}
            onClick={() => {
              triggerGAEvent(GA_LABEL_ENUMS.home_side_bar_close_click);
              toggleSidebar();
            }}
          >
            Close
          </Button>
        </div>
      ) : (
        <div className={styles.box}>
          {children}
          <div className={styles.termArrContainer}>
            {TERMS_AND_CONTACT_ARR.filter((item) => {
              if (isProduction && item.title === "About") return false;
              if (userInfo?.loggedIn) {
                return true;
              }
              if (!userInfo?.loggedIn && item.id === 1) return false;
              return true;
            }).map((i: any) => {
              return (
                <div
                  className={`${styles.sideContainer} ${!userInfo?.loggedIn && styles.terms_contact} ${
                    i.id === 4 && styles.aboutUs
                  }`}
                  key={i.id}
                >
                  <a
                    className={styles.optionsCard}
                    href={i.link}
                    rel="noreferrer"
                    target={"_self"}
                    onClick={(e) => {
                      if (i.title === "Get help" || !i.link) {
                        e.preventDefault();
                      }
                      if (i.title === "Get help") {
                        triggerGAEvent(GA_LABEL_ENUMS.sidebar_get_help);
                        setShowGetHelpOptions(!showGetHelpOptions);
                      } else {
                        toggleSidebar();
                        if (i?.title === "Terms of Service") triggerGAEvent(GA_LABEL_ENUMS.Terms_of_service_click);
                        if (i?.title === "Privacy Policy") triggerGAEvent(GA_LABEL_ENUMS.Privacy_polcy_click);
                      }
                    }}
                  >
                    <div className={styles.descCard}>
                      {i.id === 4 && <img src={i.icon} alt="info icon" className={styles.infoIcon} />}
                      <p className={styles.tripTitle}>{i.title}</p>
                    </div>
                    {i.id !== 4 && (
                      <div className={styles.arrowCard}>
                        <img src={arrowIcon} alt="" className={styles.arrowIcon} />
                      </div>
                    )}
                  </a>
                  {i.id === 0 && showGetHelpOptions && (
                    <div className={styles.getHelpCard}>
                      <p
                        className={styles.getHelp}
                        onClick={() => {
                          triggerGAEvent(GA_LABEL_ENUMS.sidebar_contact_us);
                          setLoginCreateAccountState({
                            flag: true,
                            page: DialogSelected.GET_HELP,
                          });
                          setShowGetHelpOptions(false);
                          toggleSidebar();
                        }}
                      >
                        Contact us
                      </p>

                      {userInfo.loggedIn && !isProduction && (
                        <p
                          className={styles.getHelp}
                          onClick={() => {
                            triggerGAEvent(GA_LABEL_ENUMS.sidebar_chat_with_us);
                            setShowZoho(true);
                            toggleSidebar();
                          }}
                        >
                          Chat with us
                        </p>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {!userInfo?.loggedIn && (
        <div className={`${styles.sideTermsContainer} ${!userInfo?.loggedIn && styles.loggedOutUser}`}>
          {TERMS_AND_CONTACT_ARR.filter((item) => {
            if (isProduction && item.title === "About") return false;
            if (userInfo?.loggedIn) {
              return true;
            }

            if (!userInfo?.loggedIn && item.id === 1) return false;
            return true;
          }).map((i: any) => {
            return (
              <div
                className={`${styles.sideContainer} ${!userInfo?.loggedIn && styles.terms_contact} ${
                  i.id === 4 && styles.aboutUs
                }`}
                key={i.id}
              >
                <a
                  className={styles.optionsCard}
                  href={i.link}
                  rel="noreferrer"
                  onClick={(e) => {
                    if (i.title === "Get help" || !i.link) {
                      e.preventDefault();
                    }
                    if (i.title === "Get help") {
                      triggerGAEvent(GA_LABEL_ENUMS.sidebar_get_help);
                      setShowGetHelpOptions(!showGetHelpOptions);
                    } else {
                      window.history.pushState({}, "", window.location.pathname);
                      toggleSidebar();
                      if (i?.title === "Terms of Service") triggerGAEvent(GA_LABEL_ENUMS.Terms_of_service_click);
                      if (i?.title === "Privacy Policy") triggerGAEvent(GA_LABEL_ENUMS.Privacy_polcy_click);
                    }
                  }}
                >
                  <div className={styles.descCard}>
                    {i.id === 4 && <img src={i.icon} alt="info icon" className={styles.infoIcon} />}
                    <p className={styles.tripTitle}>{i.title}</p>
                  </div>
                  {i.id !== 4 && (
                    <div className={styles.arrowCard}>
                      <img src={arrowIcon} alt="" className={styles.arrowIcon} />
                    </div>
                  )}
                </a>
                {i.id === 0 && showGetHelpOptions && (
                  <div className={styles.getHelpCardWithoutLogin}>
                    <p
                      className={styles.getWithoutLoginHelp}
                      onClick={() => {
                        setLoginCreateAccountState({
                          flag: true,
                          page: DialogSelected.GET_HELP,
                        });
                        setShowGetHelpOptions(false);
                        toggleSidebar();
                      }}
                    >
                      Contact us
                    </p>

                    {userInfo.loggedIn && !isProduction && (
                      <p
                        className={styles.getHelp}
                        onClick={() => {
                          setShowZoho(true);
                          toggleSidebar();
                        }}
                      >
                        Chat with us
                      </p>
                    )}
                  </div>
                )}
              </div>
            );
          })}
          <div className={styles.loginCard}>
            <Button
              onClickCapture={() => {
                triggerGAEvent(GA_LABEL_ENUMS.Login_in_click);
                handleSignIn();
              }}
              size="small"
              sx={{
                bgcolor: palette["red-40-v2"],
                color: colors.neutral.white,
                borderRadius: br(46.5),
                boxShadow: "none",
                textTransform: "none",
                fontFamily: "var(--brand-font-body)",
                pt: 0.5,
                pb: 0.5,
                pl: { xs: 2, sm: 2, md: 2 },
                pr: { xs: 2, sm: 2, md: 2 },
                "&:hover": {
                  bgcolor: palette["red-40-v2"],
                  color: colors.neutral.white,
                },
                width: "max-content",
                alignSelf: "center",
              }}
              variant="text"
            >
              Log in
            </Button>
          </div>
        </div>
      )}
      <p className={styles.appVersion}>Version: {APP_VERSION}</p>
    </div>
  );
};

export default SideBarFooter;
